<template>
  <div>
    <div class="detail-card card-colord-pad card-colord-01">
      <h5>Shipping Information </h5>
      <div class="container" v-if="loading">
        <div class="row">
          <div class="loading-sm"></div>
        </div>
      </div>
      <div v-else>
        <br>
        <!--Delivery-locations-->
        <h6>Delivery Locations and Prices</h6>
        <p v-if="sellpoint.business_delivery_options && (sellpoint.business_delivery_options.length == 0)" class="sp-app-default-color">
          You have not set any delivery location
        </p>
                    <!-- View and edit delivery information -->
                    <!-- <div v-for="delivery_option in sellpoint.business_delivery_options"></div> -->
                    <div v-if="!business_details.delivery_add && !business_details.delivery_add_by_dco">
                    <div class="card-flat-pad" v-for="(delivery_option_node,dvsndex) in business_delivery_options_nodes " :key="delivery_option_node.state_id">
                      <div class="" style="float: left;">
                        <b>{{delivery_option_node.state_name}}</b>
                      </div>
                      <div class="" style="float: right;">
                        <button class="btn sp-button-sm" @click="setMenuTabInnerView(menu_tab_inner_view['DVOP_S'+dvsndex] ? ' ' : 'DVOP_S'+dvsndex)"><i class="fa fa-angle-down"></i></button>
                      </div>
                      <div style="clear: both;"></div>
                      <div class="card card-flat-pad" v-if="menu_tab_inner_view['DVOP_S'+dvsndex]">
                        <div v-for="delivery_option in delivery_option_node.state_locations" :key="delivery_option.business_delivery_option">
                          <!-- Edit delivery information -->
                          <div v-if="business_details.delivery_option_edit && delivery_option.edit_set" class="contact_form" :key="componentDeliveryKey">
                            
                            <h5 style="color:#ff0000;">Editing {{delivery_option.business_delivery_option}}</h5>
      
                            <div v-if="delivery_option.business_delivery_is_custom && (delivery_option.business_delivery_is_custom == 1)">
                              <div class="form-group">
                                <label>Delivery Location</label>
                                <textarea class="form-control" v-model="delivery_option.business_delivery_custom_option"></textarea>
                              </div>
                            </div>
      
                            <div v-else>
                              <div class="form-group">
                                <label>State: <b>{{delivery_option.business_delivery_state}}</b></label>
                                <select class="form-control" v-model="delivery_option.business_delivery_state_id" @change="getCities(delivery_option.business_delivery_state_id,'edit')">
                                <option :value="undefined">Select State</option>
                                <option v-for="state in states" :value="state.state_id" :key="state.state_id">{{state.name}}</option>
                                </select>
                              </div>
                              <!-- <li v-if="cities.length && cities.length != 0 && edit_city"> -->
                              <div class="form-group">
                                <label>City: <b>{{delivery_option.business_delivery_option}}</b></label>
                                <select class="form-control" v-model="delivery_option.city" @change="setOtherOptions(delivery_option.city,'edit')">
                                <option :value="undefined">Select City</option>
                                <option value="all">All Areas @Fixed Price</option>
                                <option v-for="city in cities" :value="city.city_id" :key="city.city_id">{{city.city_name}}</option>
                                <option value="other">Other Areas / Cities </option>
                                </select>
                              </div>
                              <div class="form-group" v-if="edit_other_delivery_option">
                                  <label>Other Areas / Cities</label>
                                  <input type="text" class="form-control" placeholder="eg. Abuja" v-model="delivery_option.business_delivery_other_option"/><br>
                              </div>
                              <!-- <input v-model="delivery_option.business_delivery_option" type="text" required/> -->
                            </div>

                            <div class="form-group">
                              <label>Free Delivery?</label>
                              <input type="checkbox" v-model="delivery_option.business_delivery_option_free" @click="setFreeDelivery(2)"/>
                            </div>

                            <div class="form-group" v-if="delivery_option.business_delivery_option_free != 1">
                              <label>Delivery Amount</label>
                              <input class="form-control" v-model="delivery_option.business_delivery_option_price" type="number" required/>
                            </div>
      
                            <div class="form-group">
                              <div class="loading-sm" v-if="action_loading"></div>
                              <p style="color:#ff0000;">{{data_processing_message}}</p>
                              <button :disabled="disable_btn" class="btn sp-button-02" style="line-height:1.6; padding:10px" title="save" type="submit" @click="editDeliveryOption">Save</button>
                              <button class="btn sp-button-02" style="line-height:1.6; padding:10px;" title="cancel" type="submit" @click="setComponent('reset-edit','')">Cancel</button>
                            </div>
      
                          </div>
                          <!-- ./Edit delivery information -->
                            
                          <!-- View delivery information -->
                          <div v-else>
                            <div v-if="delivery_option.business_delivery_product == 0">
                              <span v-if="((sellpoint.business_category_id != 37) && (delivery_option.business_is_delivery_business == 1))" style="font-size: 12px; color: #96c5f5;">{{delivery_option.business_delivery_business_name}}<br></span>
                              {{delivery_option.business_delivery_option}} - {{delivery_option.business_delivery_option_price}}
                              <span v-if="sellpoint.business_id == delivery_option.business_delivery_option_business">
                                <button type="button" class="btn sp-button-02 sp-button-sm" @click="setComponent('edit-delivery-option',delivery_option)"><i class="fa fa-pencil"></i></button>
                                <button :disabled="disable_btn" type="button" class="btn sp-button-02 sp-button-sm" @click="deleteDeliveryOption(delivery_option.business_delivery_option_id)"><i class="fa fa-trash"></i></button>
                                <button v-if="sellpoint.business_category_id == 37" class="btn sp-button-02 sp-button-sm" type="button" @click="setComponent('set-business-details','delivery_add_by_dco'); setDeliveryOptionParams(delivery_option,'add-new-from'); "><i class="fa fa-plus"></i></button>
                                <!-- <a style="cursor:pointer; color: inherit;"  @click="toggleSingleComponent('vfo')">
                                  <span style="padding: 0.15em; border:1px solid #000000; border-radius: 50%;"><b>&#x25BC;</b></span>
                                </a> -->
                              </span>
                              <hr/>
                              <div style="clear: both;"></div>
                              <div id="vfo" style="display:none;">
                                <div class="card-flat-pad" v-for="(delivery_option_from_node,dvfndex) in delivery_option.business_delivery_from_points_states_nodes" :key="delivery_option_from_node.state_id">
                                  <div class="" style="float: left;">
                                    <b>{{delivery_option_from_node.state_name}}</b>
                                  </div>
                                  <div class="" style="float: right;">
                                    <button class="btn sp-button-sm" @click="toggleSingleComponent('vfn'+dvfndex)"><i class="fa fa-angle-down"></i></button>
                                  </div>
                                  <div style="clear: both;"></div>
                                  <div style="display:none;" class="card card-flat-pad" :id="'vfn'+dvfndex" >
                                      <div v-for="dv_from in delivery_option_from_node.state_locations" :key="dv_from.business_delivery_option_id">
                                        {{dv_from.business_delivery_from_location}} <b>to</b> {{delivery_option.business_delivery_option}} - {{dv_from.business_delivery_from_price}}
                                        <button type="button" class="btn sp-button-02 sp-button-sm" @click="setComponent('edit-delivery-option',delivery_option)"><i class="fa fa-pencil"></i></button>
                                        <button :disabled="disable_btn" type="button" class="btn sp-button-02 sp-button-sm" @click="updateDeliveryFromOption('delete-delivery-from',dv_from)"><i class="fa fa-trash"></i></button>
                                        <button v-if="sellpoint.business_category_id == 37" class="btn sp-button-02 sp-button-sm" type="button" @click="setComponent('set-business-details','delivery_add_by_dco'); setDeliveryOptionParams(delivery_option,'add-new-from'); "><i class="fa fa-plus"></i></button>
                                        <a style="cursor:pointer; color: inherit;"  @click="toggleSingleComponent('vfo')">
                                          <span style="padding: 0.15em; border:1px solid #000000; border-radius: 50%;"><b>&#x25BC;</b></span>
                                        </a>
                                        <br>
                                        <div class="form-group">
                                          <label>Update Delivery Amount</label>
                                          <input class="form-control" v-model="dv_from.business_delivery_from_price" type="number" required/>
                                        </div>
                                        <div class="form-group">
                                          <div class="loading-sm" v-if="action_loading"></div>
                                          <p style="color:#ff0000;">{{data_processing_message}}</p>
                                          <button :disabled="disable_btn" class="btn sp-button-02 sp-button-sm" style="line-height:1.6; padding:10px" title="save" type="submit" @click="updateDeliveryFromOption('edit-delivery-from',dv_from)">Save</button>
                                          <button class="btn sp-button-02 sp-button-sm" style="line-height:1.6; padding:10px;" title="cancel" type="submit" @click="setComponent('reset-edit','')">Cancel</button>
                                        </div>
                                      </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- ./ View delivery information -->
                        </div>
                      </div>
                    </div> 
                    </div> 
                    <!-- /.View and Edit delivery informatin -->
                    <div class="card">
                      <div v-if="!business_details.delivery_add"> <!--not-a-logistics-business(37)-->
                        <button v-if="sellpoint.business_category_id == 37" class="btn sp-button-02 sp-button-sm" type="submit" @click="setComponent('set-business-details','delivery_add_by_dco')">Set New Delivery Location</button>
                        <button v-else class="btn sp-button-02 sp-button-sm" type="submit" @click="setComponent('set-business-details','delivery_add')">Add New Delivery Information</button>
                      </div> 
                      <hr/>
                      <div style="display: none;">
                        <div v-if="sellpoint.business_category_id != 37"> <!--not-a-logistics-business(37)-->
                          <button  v-if="!business_details.delivery_add" class="btn sp-button-02 sp-button-sm" type="submit" @click="setMenuTabInnerView('addDeliveryPartner')">Add A Delivery / logistics partner</button>
                          <div v-if="menu_tab_inner_view.addDeliveryPartner">
                            <h3>Select Delivery Partner</h3>
                            <div v-for="dp in delivery_partners" :key="dp.business_delivery_partner_name">
                              <a @click="addDeliveryPartner(dp)">
                              <p>{{dp.business_delivery_partner_name}}</p>
                              </a>
                            </div>
                          </div>
                        </div>
                        <hr/>
                      </div>
                    </div>
                    <!--Add new delivey Information -->
                    <div class="card" v-if="business_details.delivery_add" :key="componentDeliveryKey">
                      <h5>Add a Delivery Location and Price</h5>
                        <!-- <input type="checkbox" v-model="custom_delivery_option"/> Do you want to add customised delivery locations(Suitable for Countries outside Nigeria)
                        <div v-if="custom_delivery_option">
                          <div class="form-group">
                            <label>Delivery Location</label>
                            <textarea class="form-control" placeholder="eg. Country, City, Location" v-model="delivery_option.delivery_custom_option"></textarea>
                          </div>
                        </div>
                        <div v-else> -->
                        <div>
                          <div class="form-group">
                            <label>State</label>
                            <select class="form-control" v-model="delivery_option.state" @change="getCities(delivery_option.state,'')">
                                <option :value="undefined">Select State</option>
                                <option v-for="state in states" :value="state.state_id" :key="state.state_id">{{state.name}}</option>
                            </select>
                          </div>
                          <!-- <div class="loading-sm" v-if="action_loading"></div> -->
                          <div v-if="action_loading"><p>...loading cities</p></div>
                          <div class="form-group" v-if="cities.length && cities.length != 0 && !edit_city">
                            <label>City</label>
                            <select class="form-control" v-model="delivery_option.city" @change="setOtherOptions(delivery_option.city,'')">
                                <option :value="undefined">Select City</option>
                                <option value="all">All Areas @Fixed Price</option>
                                <option v-for="city in cities" :value="city.city_id" :key="city.city_id">{{city.city_name}}</option>
                                <option value="other">Other Areas / Cities </option>
                            </select>
                          </div>
                          <div class="form-group" v-if="other_delivery_option">
                            <label>Other Areas / Cities</label>
                            <input type="text" class="form-control" placeholder="eg. Abuja" v-model="delivery_option.delivery_other_option"/><br>
                          </div>
                        </div>
                        <div class="form-group">
                          <label>Free Delivery?</label>
                          <input type="checkbox" v-model="delivery_option.delivery_option_free" @click="setFreeDelivery(1)"/>
                        </div>
                        <div class="form-group" v-if="delivery_option.delivery_option_free != 1">
                          <label>Delivery Charge</label>
                          <input type="number" class="form-control" placeholder="eg. 1000" v-model="delivery_option.delivery_option_price"/><br>
                        </div>
                        <div class="loading-sm" v-if="action_loading"></div>
                        <p style="color:#ff0000;">{{data_processing_message}}</p>
                        <button :disabled="disable_btn" style="" class="btn sp-button-02 sp-button-md" @click="addDeliveryOption">Add</button>
                        <button class="btn sp-button-02 sp-button-md" type="submit" @click="setComponent('reset-edit','')">Cancel</button>
                    </div>
                    <!-- ./Add new delivery Information -->
                    <!--#DCO#-Add new delivey Information -->
                    <div class="card" v-if="business_details.delivery_add_by_dco" :key="deliveryAddByDcoKey">
                      <h5>Add a new Delivery Location and Price</h5>
                        <div v-if="(delivery_option.city) || ((delivery_option.business_delivery_city) && (delivery_option.business_delivery_city > 0))">
                          <p>Delivering to <b>{{delivery_option.business_delivery_option}}</b></p>{{delivery_option.business_delivery_option_id}}
                        </div>
                        <div v-else>
                          <input type="checkbox" v-model="custom_delivery_option"/> Do you want to add customised delivery locations(Suitable for Countries outside Nigeria)
                          <div v-if="custom_delivery_option">
                            <div class="form-group">
                              <label>Delivery Location</label>
                              <textarea class="form-control" placeholder="eg. Country, City, Location" v-model="delivery_option.delivery_custom_option"></textarea>
                            </div>
                          </div>
                          <div v-else>
                            <hr/>
                            <div class="form-group">
                              <label>What State is this location <span class="sp-form-descr sp-app-default-color">You will add delivery points to this location</span></label>
                              <select class="form-control" v-model="delivery_option.state" @change="getCities(delivery_option.state,'')">
                                  <option :value="undefined">Select State</option>
                                  <option v-for="state in states" :value="state.state_id" :key="state.state_id">{{state.name}}</option>
                              </select>
                            </div>
                            <!-- <div class="loading-sm" v-if="action_loading"></div> -->
                            <div v-if="action_loading"><p>...loading cities</p></div>
                            <div class="form-group" v-if="cities.length && cities.length != 0 && !edit_city">
                              <label>Name of Location</label>
                              <select class="form-control" v-model="delivery_option.city" @change="setOtherOptions(delivery_option.city,'')">
                                  <option :value="undefined">Select City</option>
                                  <option value="all">All Areas @Fixed Price</option>
                                  <option v-for="city in cities" :value="city" :key="city.city_id">{{city.city_name}}</option>
                                  <option value="other">Other Areas / Cities </option>
                              </select>
                            </div>
                            <div class="form-group" v-if="other_delivery_option">
                              <label>Other Areas / Cities</label>
                              <input type="text" class="form-control" placeholder="eg. Abuja" v-model="delivery_option.delivery_other_option"/><br>
                            </div>
                          </div>
                        </div>
                        <div class="card card-flat-pad" v-if="(delivery_option.city) || ((delivery_option.business_delivery_city) && (delivery_option.business_delivery_city > 0))">
                          <h5 style="color:#df4d4d">Set location <b>FROM</b> points</h5>
                          <div class="card">
                            <div class="form-group">
                              <label>Delivering from this State <span class="sp-form-descr sp-app-default-color">You will add delivery points to this location</span></label>
                              <select class="form-control" v-model="delivery_option.dvco_state" @change="set_dvco_delivery_option = true; getCities(delivery_option.dvco_state,'')">
                                  <option :value="undefined">Select State</option>
                                  <option v-for="state in states" :value="state.state_id" :key="state.state_id">{{state.name}}</option>
                              </select>
                            </div>
                            <!-- <div class="loading-sm" v-if="action_loading"></div> -->
                            <div v-if="action_loading"><p>...loading cities</p></div>
                            <div class="form-group" v-if="dvco_cities.length && dvco_cities.length != 0">
                              <label>Locations</label>
                              <div v-for="(city,dvco_city_index) in dvco_cities" :key="city.city_id">
                                <!-- <b>{{city.city_name}} -</b> {{delivery_option.city.city_name}}<br> -->
                                <div v-if="(delivery_option.city) && (delivery_option.city.length && delivery_option.city.length != 0)">
                                  <b>{{city.city_name}} -</b> {{delivery_option.city.city_name}}<br>
                                </div>
                                <div v-if="((delivery_option.business_delivery_option_id) && (delivery_option.business_delivery_option_id > 0))">
                                  <b>{{city.city_name}} -</b> {{delivery_option.business_delivery_option}}<br>
                                </div>
                                <span>Delivery Charge: <input type="number" class="form-control" placeholder="eg. 1000" v-model="dvco_cities[dvco_city_index].delivery_option_price"/></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="loading-sm" v-if="action_loading"></div>
                        <p style="color:#ff0000;">{{data_processing_message}}</p>
                        <div v-if="dvco_cities.length && dvco_cities.length != 0">
                          <button :disabled="disable_btn" style="" class="btn sp-button-02 sp-button-md" @click="addDeliveryOption">Add</button>
                          <button class="btn sp-button-02 sp-button-md" type="submit" @click="setComponent('reset-edit','')">Cancel</button>
                        </div>
                    </div>
                    <!-- ./Add new delivery Information -->
                    <!--./Delivery-locations-->
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
                // user:this.$store.getters['account/getUser'],
                // business:this.$store.getters['account/getUserBusiness'],
            }
        },

        methods: {
            setPage(){
                this.loading = true;
                //call funcs
                this.getBusinessDeliveryOptions();
            },
        },

        components: {},

        created: function(){
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                    self.setPage();
                }else{}
            });
        }

    }
</script>


// WEBPACK FOOTER //
// SellpointShipping.vue?d6569906